import React, { useState } from "react";
import Board from "./Board";
import { GameChecker } from "../utils/gameChecker";

interface PlayableBoardProps {
  icons: string[]; // shuffled icons
  checker: GameChecker;
  startDate?: string;
  nextStartDate?: string | null;
  isPreview?: boolean;
  onFinish?: (result: { won: boolean; tries: number; seconds: number }) => void;
}

// Holds the game state (locked rows, hearts) around the Board.
// Used by the live game and by the admin's "Test puzzle".
const PlayableBoard: React.FC<PlayableBoardProps> = ({ icons, checker, startDate, nextStartDate, isPreview, onFinish }) => {
  const [tiles] = useState(() => icons.map((icon) => ({ icon })));
  const [completedRows, setCompletedRows] = useState<boolean[]>([false, false, false, false]);
  const [guessesLeft, setGuessesLeft] = useState(4);
  const [incorrectGuesses, setIncorrectGuesses] = useState(0);
  const playing = guessesLeft > 0 && !completedRows.every(Boolean);

  const handleRowCompletion = (rowIndices: number[], wasIncorrect = false) => {
    setCompletedRows((prev) => {
      const next = [...prev];
      rowIndices.forEach((i) => (next[i] = true));
      return next;
    });
    if (wasIncorrect) {
      setGuessesLeft((g) => g - 1);
      setIncorrectGuesses((n) => n + 1);
    }
  };

  return (
    <Board
      tiles={tiles}
      onRowComplete={playing ? handleRowCompletion : () => {}}
      completedRows={completedRows}
      guessesLeft={guessesLeft}
      incorrectGuesses={incorrectGuesses}
      checker={checker}
      startDate={startDate}
      nextStartDate={nextStartDate}
      isPreview={isPreview}
      onFinish={onFinish}
    />
  );
};

export default PlayableBoard;
